<template>
  <ul class="dropdown" :id="id">
    <li
      v-for="(item, i) in itemsFiltered"
      :key="`i-${i}`"
      :data-value="item.Ref"
    >
      <a href="#" @click.stop.prevent="onSelect(item.Ref)">
        {{ itemName(item) }}
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'InputDropdown',
  props: {
    items: {
      type: Array,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    filter: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    itemsFiltered() {
      if (this.filter === '') {
        return this.items
      }
      return this.items.filter(v => {
        const name =
          this.$i18n.locale === 'ru' ? v.DescriptionRu : v.Description
        return name.toLowerCase().indexOf(this.filter.toLowerCase()) !== -1
      })
    },
  },
  methods: {
    onSelect(id) {
      // console.log(id)
      this.$emit('onItemSelected', id)
    },
    itemName(item) {
      let s = this.$i18n.locale === 'ru' ? item.DescriptionRu : item.Description
      if (item.AreaDescriptionRu) {
        s += ' ' + item.AreaDescriptionRu
      } else if (item.AreaDescription) {
        s += ' ' + item.AreaDescription
      }
      return s
    },
  },
}
</script>

<style>
/* todo: fix styling */
.dropdown-content {
  max-height: 240px;
  overflow-y: auto;
  overflow-x: hidden;
}
.dropdown {
  max-height: 240px;
  overflow-y: auto;
  overflow-x: hidden;
  top: 100%;
  left: 0;
  min-width: 400px;
  font-size: 14px;
  text-align: left;
  list-style: none;
  background-color: #fff;
  /*-webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12),
    0 1px 5px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12),
    0 1px 5px 0 rgba(0, 0, 0, 0.2);*/
  border-bottom: 1px solid #e6e6e6;
  margin: 0 20px 0 0 !important;
}
.dropdown li {
  clear: both;
  cursor: pointer;
  width: 100%;
  outline: 0;
  text-align: left;
  padding: 0 0 0 20px !important;
}
.dropdown li:hover {
  background: #f0f0f0;
}
.dropdown li > a,
.dropdown li > span {
  display: block;
  font-size: 14px;
  color: #999;
  text-align: left;
  /* font-family: 'Proxima Nova Regular'; */
  font-family: 'Nunito', sans-serif;
  padding: 0;
}
/*.dropdown li > a:hover,
.dropdown li > span:hover {
  background-color: rgba(0, 0, 0, 0.53);
}*/
</style>
